/**
 * Analytics configuration constants
 * These values could be made configurable via API endpoints in the future
 */

// Market concentration analysis thresholds
export const MARKET_CONCENTRATION = {
  HIGH_THRESHOLD: 80,    // Above this percentage = high concentration
  MEDIUM_THRESHOLD: 60   // Above this percentage = medium concentration
};

// Progress bar and display thresholds
export const DISPLAY_THRESHOLDS = {
  PROGRESS_LABEL: 15,    // Minimum percentage to show labels on progress bars
  MIN_STATE_DATA: 0      // Minimum value to include state in analyses
};

// Radar chart scaling factors for normalization (0-10 scale)
export const RADAR_SCALING = {
  PLAYERS: 100,          // Divide total players by this for 0-10 scale
  SESSIONS: 50,          // Divide total sessions by this for 0-10 scale
  BLOCKS: 5000,          // Divide total blocks by this for 0-10 scale
  TIME: 100000,          // Divide total time by this for 0-10 scale
  RETENTION_MULTIPLIER: 5,  // Multiply sessions per player by this
  COMPLETION: 50         // Divide avg blocks per player by this
};

// Chart configuration
export const CHART_CONFIG = {
  PIE_CHART_RADIUS: 120,
  PIE_CHART_CENTER_X: 150,
  PIE_CHART_CENTER_Y: 150,
  DOUGHNUT_CUTOUT: '60%',
  ANIMATION_DURATION: 1000
};

// Time formatting thresholds
export const TIME_FORMAT = {
  SECONDS_IN_MINUTE: 60,
  SECONDS_IN_HOUR: 3600
};

// Default API configuration (could be moved to environment variables)
export const API_CONFIG = {
  DEFAULT_DATE_RANGE_DAYS: 30,
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyAS16PdKwFzuFqleusplzN0Sr1Q0mROOZI'
};

// Export utility functions that use these constants
export const getMarketConcentrationLevel = (percentage) => {
  if (percentage > MARKET_CONCENTRATION.HIGH_THRESHOLD) return 'High';
  if (percentage > MARKET_CONCENTRATION.MEDIUM_THRESHOLD) return 'Medium';
  return 'Low';
};

export const shouldShowProgressLabel = (percentage) => {
  return percentage > DISPLAY_THRESHOLDS.PROGRESS_LABEL;
};

export const isValidStateData = (completion, medianTime, medianBlocks) => {
  return completion > DISPLAY_THRESHOLDS.MIN_STATE_DATA || 
         medianTime > DISPLAY_THRESHOLDS.MIN_STATE_DATA || 
         medianBlocks > DISPLAY_THRESHOLDS.MIN_STATE_DATA;
};
